import { ONBOARDING_PAGE } from 'global/routes';

export const KGLOnboardingRoutes = {
  WELCOME: `${ONBOARDING_PAGE}/welcome`,
  YOUR_INFO: `${ONBOARDING_PAGE}/your-info`,
};
